import { render, staticRenderFns } from "./Life_insurance_opportunity.vue?vue&type=template&id=3226a4ac&scoped=true&"
import script from "./Life_insurance_opportunity.vue?vue&type=script&lang=js&"
export * from "./Life_insurance_opportunity.vue?vue&type=script&lang=js&"
import style0 from "./Life_insurance_opportunity.vue?vue&type=style&index=0&id=3226a4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3226a4ac",
  null
  
)

export default component.exports